export default {
    mapBoxKey: 'pk.eyJ1IjoiY2hhZGRhbmtlciIsImEiOiJjazcxc2E1bnIwMmE0M21ud2oxOTdhNTlvIn0.vPS-2MWv9PRKcuRmmJG13w',
    socketUri: 'https://dry-tundra-13378.herokuapp.com'
}